import Axios from "axios";
import searchClient from "@/services/azuresearch.service";
import SearchStringBuilder from "@/logic/searchstringbuilder.logic.js";

// const baseUrl = "https://jupiterstoreservice.azurewebsites.net/api";
const baseUrlFunc = "https://jupiterfunctions.azurewebsites.net/api";
const categoriesUrl = `${baseUrlFunc}/GetTypesByCountryId?id=1`;
const suppliersUrl = `${baseUrlFunc}/GetSuppliersByCountryId?id=1`;
const manufacturersUrl = `${baseUrlFunc}/GetAllManufacturers`;
// const promoItemsUrl = `${baseUrlFunc}/GetPromoItemsByCountryId?CountryId=1`;
// const getItemsUrl = `${baseUrlFunc}/GetItemsByTypeIdAndCountryId?`;

const ssb = new SearchStringBuilder();

export default {
  async executeSearch({ dispatch, state, commit }) {
    const searchResults = await searchClient.search(state.searchString, {
      includeTotalCount: true,
      queryType: "full",
      searchMode: "any",
      highlightFields: "ItemName,Description",
      searchFields: ["ItemName", "Description", "CommercialTypeNumber"],
      orderBy: state.orderBy,
      facets: [
        "ManufacturerID,count:100",
        "ManufacturerName",
        "Promo",
        "ItemSuppliers",
      ],
      top: state.resultsPerPage,
      skip: (state.currentPage - 1) * state.resultsPerPage,
    });

    commit("SET_RESULTS_COUNT", await searchResults.count);

    console.log("search results: ");
    console.log(await searchResults);
    commit("SET_FACETS", await searchResults.facets);

    commit("FILTER_MANUFACTURER_FACETS");
    commit("FILTER_SUPPLIER_FACETS");

    let resultsArray = [];

    console.log("results: ");
    for await (const result of searchResults.results) {
      result.document.thumbnail = "blanco";
      result.document.manufacturerImage = "blanco";
      resultsArray.push(result);
      console.log(result);
    }

    console.log("SEARCH STRING:");
    console.log(state.searchString);

    commit("SET_RESULTS", resultsArray);

    dispatch("getImages");
    dispatch("getManufacturerImages");
  },

  async getImages({ state, commit }) {
    await Axios.post(state.getImagesUrl, {
      itemIds: state.itemIds,
    }).then((response) => {
      commit("SET_ITEMIMAGES", response.data);
    });
  },

  async getManufacturerImages({ state, commit }) {
    await Axios.post(state.getManufacturerImagesUrl, {
      itemIds: state.itemManufacturerIds,
    }).then((response) => {
      commit("SET_MANUFACTURERIMAGES", response.data);
    });
  },

  setSearchString({ dispatch, commit, state }) {
    console.log(state.rawString + " raw " + state.selectedCategoryId);
    ssb.update(
      state.rawString,
      state.selectedCategoryId,
      state.filteredManufacturerIds,
      state.filteredSupplierIds,
      state.isPromo
    );
    commit("SET_SEARCHSTRING", ssb.azureString);
    dispatch("executeSearch");
  },

  async getPromoItems({ dispatch, commit }) {
    commit("SET_PROMO", true);
    ssb.update("", null, null, null, true);
    commit("SET_SEARCHSTRING", ssb.azureString);
    dispatch("executeSearch");

    // await Axios.get(promoItemsUrl).then((response) =>
    //   context.commit("setProducts", response.data)
    // );
  },

  setRawString({ commit }, value) {
    commit("SET_CURRENT_PAGE", 1);
    commit("SET_RAWSTRING", value);
    commit("SET_PROMO", false);

    // reset sorting by price when searching new string
    commit("SET_PRICESORTING", 0);
  },

  setSelectedCategoryId({ dispatch, commit }, categoryId) {
    commit("SET_CURRENT_PAGE", 1);
    commit("SET_SELECTEDCATEGORYID", categoryId);
    commit("SET_PROMO", false);

    dispatch("setSearchString");
  },

  setCurrentPage({ dispatch, commit }, page) {
    commit("SET_CURRENT_PAGE", page);
    dispatch("setSearchString");
  },

  setPriceSorting({ dispatch, commit }, sortingValue) {
    commit("SET_PRICESORTING", sortingValue);
    dispatch("setSearchString");
  },

  async getCategories(context) {
    await Axios.get(categoriesUrl).then((response) =>
      context.commit("setCategories", response.data)
    );
  },
  async getManufacturers(context) {
    await Axios.get(manufacturersUrl).then((response) =>
      context.commit("SET_MANUFACTURERS", response.data)
    );

    // Now when we have got manufacturers, we should
  },
  async getSuppliers(context) {
    await Axios.get(suppliersUrl).then((response) =>
      context.commit("SET_SUPPLIERS", response.data)
    );
  },
  // async getItemsByCategoryIdAndCountryId(context, categoryId) {
  //   // console.log(categoryId);
  //   let itemsUrl = getItemsUrl + "typeId=" + categoryId + "&countryId=1";
  //   await Axios.get(itemsUrl).then((response) =>
  //     context.commit("setProducts", response.data)
  //   );
  // },
};
